import { render, staticRenderFns } from "./WAddWorkPartnerDialog.vue?vue&type=template&id=9cfb189c&"
import script from "./WAddWorkPartnerDialog.vue?vue&type=script&lang=js&"
export * from "./WAddWorkPartnerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports